        
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->

<div class="header-actions">
    <a class="mat-link-button" [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5">
        <span (click)="play()" class="opcode1">{{ userData.email}}</span> <mat-icon>arrow_drop_down</mat-icon>
    </a>
</div>
<mat-menu #profile="matMenu" class="mymegamenu">
    <!-- <button mat-menu-item>
        <mat-icon [style.color]="'#91C326'">account_box</mat-icon> Profile </button> -->
    <!-- <a mat-menu-item routerLink="password">
        <mat-icon [style.color]="'#FF5959'">lock</mat-icon> Change Password </a> -->
    <button (click)="logoutUser()" mat-menu-item>
        <mat-icon [style.color]="'#7D0CE4'">exit_to_app</mat-icon> Sign Out </button>
</mat-menu>

<img src="" alt="">
